(() => {
  const cardSelector = '.lp-card-gallery';
  const galleryStates = new WeakMap();
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getState(card) {
    if (galleryStates.has(card)) return galleryStates.get(card);
    const image = card.querySelector('.card__media .media > img');
    const data = card.querySelector('.lp-card-gallery-data');
    if (!image || !data) return null;

    let photos;
    try {
      photos = JSON.parse(data.textContent);
    } catch (_) {
      return null;
    }
    if (!Array.isArray(photos) || photos.length < 2) return null;

    const state = {
      image,
      photos,
      index: 0,
      originalSrc: image.getAttribute('src'),
      originalSrcset: image.getAttribute('srcset'),
      originalAlt: image.getAttribute('alt'),
      timer: null,
      delay: null,
      request: 0,
    };
    galleryStates.set(card, state);
    return state;
  }

  function updateCounter(card, state) {
    const counter = card.querySelector('.lp-card-gallery-count');
    if (counter) counter.textContent = `${state.index + 1} / ${state.photos.length}`;
  }

  function showPhoto(card, state, nextIndex) {
    const index = (nextIndex + state.photos.length) % state.photos.length;
    const photo = state.photos[index];
    if (!photo || !photo.src || index === state.index) return;
    const request = ++state.request;
    const preload = new Image();
    preload.onload = () => {
      if (request !== state.request || !card.isConnected) return;
      state.image.removeAttribute('srcset');
      state.image.src = photo.src;
      state.image.alt = photo.alt || state.originalAlt || '';
      state.index = index;
      updateCounter(card, state);
    };
    preload.src = photo.src;
  }

  function stop(card, reset = true) {
    const state = getState(card);
    if (!state) return;
    clearTimeout(state.delay);
    clearInterval(state.timer);
    state.delay = null;
    state.timer = null;
    ++state.request;
    if (!reset || state.index === 0) return;
    state.image.src = state.originalSrc;
    if (state.originalSrcset) state.image.setAttribute('srcset', state.originalSrcset);
    state.image.alt = state.originalAlt || '';
    state.index = 0;
    updateCounter(card, state);
  }

  function start(card) {
    if (!canHover.matches || reduceMotion.matches) return;
    const state = getState(card);
    if (!state || state.timer || state.delay) return;
    state.delay = setTimeout(() => {
      state.delay = null;
      showPhoto(card, state, state.index + 1);
      state.timer = setInterval(() => showPhoto(card, state, state.index + 1), 1600);
    }, 500);
  }

  document.addEventListener('pointerover', (event) => {
    const card = event.target.closest?.(cardSelector);
    if (card && !card.contains(event.relatedTarget)) start(card);
  });

  document.addEventListener('pointerout', (event) => {
    if (!canHover.matches) return;
    const card = event.target.closest?.(cardSelector);
    if (card && !card.contains(event.relatedTarget)) stop(card);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.lp-card-gallery-button');
    if (!button) return;
    const card = button.closest(cardSelector);
    const state = card && getState(card);
    if (!state) return;
    event.preventDefault();
    event.stopPropagation();
    clearTimeout(state.delay);
    clearInterval(state.timer);
    state.delay = null;
    state.timer = null;
    showPhoto(card, state, state.index + Number(button.dataset.step));
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll(cardSelector).forEach((card) => stop(card));
  });
})();
